import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { environment } from "../../../environments/environment";

import { LoginComponent } from "./login/login.component";
import { RegisterComponent } from "./register/register.component";
import { PartnerLoginComponent } from "./partner-login/partner-login.component";
import { PartnerRegisterComponent } from "./partner-register/partner-register.component";
import { ForgotPasswordComponent } from "./../forgot-password/forgot-password.component";

import { NgxCaptchaModule } from "ngx-captcha";

import { SocialLoginModule, AuthServiceConfig } from "angularx-social-login";
import { GoogleLoginProvider } from "angularx-social-login";

const config = new AuthServiceConfig([
  {
    id: GoogleLoginProvider.PROVIDER_ID,
    provider: new GoogleLoginProvider(environment.googleKey)
  }
]);

export function provideConfig() {
  return config;
}

@NgModule({
  declarations: [
    LoginComponent,
    RegisterComponent,
    ForgotPasswordComponent,
    PartnerRegisterComponent,
    PartnerLoginComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SocialLoginModule,
    NgxCaptchaModule
  ],
  exports: [
    LoginComponent,
    RegisterComponent,
    ForgotPasswordComponent,
    PartnerRegisterComponent,
    PartnerLoginComponent
  ],
  providers: [{ provide: AuthServiceConfig, useFactory: provideConfig }]
})
export class LoginRegisterModule {}
